<template>
  <router-view />
  <v-btn v-if="showScrollTop" icon large color="primary" class="scroll-to-top" @click="scrollToTop">
    <v-icon>mdi-chevron-up</v-icon>
  </v-btn>
</template>

<script setup>
import { useHead } from '@vueuse/head';
import { ref, onMounted, onBeforeUnmount } from 'vue';

useHead({
  title: 'Home Page - JamSplit',
  meta: [
    // Standard meta tags for SEO
    { name: 'description', content: 'JamSplit is a web application that makes it easy for bands and musicians to upload, edit, and share recordings of their jam sessions and performances' },
    { name: 'keywords', content: 'JamSplit, music sharing, jam sessions, music collaboration, audio editing, share performances' },

    // Open Graph meta tags for social media previews
    { property: 'og:title', content: 'Home Page - JamSplit' },
    { property: 'og:description', content: 'JamSplit is a web application that makes it easy for bands and musicians to upload, edit, and share recordings of their jam sessions and performances' },
    { property: 'og:site_name', content: 'JamSplit' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.jamsplit.com' },
    { property: 'og:image', content: 'https://www.jamsplit.com/images/home-preview.jpg' },

    // Twitter meta tags for sharing on Twitter
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Home Page - JamSplit' },
    { name: 'twitter:description', content: 'Discover, create, and share music on JamSplit – the ultimate platform for musicians to upload, edit, and collaborate on jam sessions.' },
    { name: 'twitter:image', content: 'https://www.jamsplit.com/images/home-preview.jpg' }, // Optional: replace with your own image URL

    // Robots meta tag to ensure proper indexing
    { name: 'robots', content: 'index, follow' },
  ],
});

const showScrollTop = ref(false)

const onScroll = () => {
  showScrollTop.value = window.scrollY > 200
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})

</script>

<style>
.v-btn {
  text-transform: none !important;
}

.router-link {
  color: inherit;
}

.router-link:hover {
  color: #ea2776 !important;
}

.text-max-100 {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-max-200 {
  max-width: 200px;
  width: fit-content;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-max-240 {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-max-h-20 {
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.z-index-50 {
  z-index: 50;
}

/* feed & following */
.profile-photo {
  border: solid 2px white;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
}

.profile-card {
  transition: all .15s ease-in-out;
}

.profile-card:hover {
  transform: scale(1.01);
}

.scroll-to-top {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 100;
  opacity: 0.6;
  transition: all .2s ease-in-out;
}

.scroll-to-top:hover {
  opacity: 1;
}
</style>
